import React from 'react'
import { Flex, Box } from 'rebass'
import { IconButtonCheckSquare, IconButtonEdit, IconButtonXSquare } from '../ActionButton'
import { theme } from 'theme'
import { GridRenderCellParams, useGridRootProps } from '@mui/x-data-grid-pro'

interface ActionCellProps extends GridRenderCellParams {
    disableRequestEdit?: boolean
    disableApprove?: boolean
}

export const ActionCell = (cellParams: ActionCellProps) => {
    const { componentsProps } = useGridRootProps()
    return (
        <Flex>
            <Box mr={theme.spacing.xxs}>
                <IconButtonCheckSquare
                    onClick={(): void => {
                        if (componentsProps) {
                            componentsProps.toolbar.setSelectedRowId([+cellParams.row.id])
                            componentsProps.toolbar.onClickApprove(cellParams.row.uuid)
                        }
                    }}
                    isDisabled={cellParams.disableApprove}
                />
            </Box>
            <Box mr={theme.spacing.xxs}>
                <IconButtonEdit
                    onClick={(): void => {
                        if (componentsProps) {
                            componentsProps.toolbar.setSelectedRowId([+cellParams.row.id])
                            componentsProps.toolbar.onClickRequestEdit(cellParams.row.uuid)
                        }
                    }}
                    isDisabled={cellParams.disableRequestEdit}
                />
            </Box>
            <Box>
                <IconButtonXSquare
                    onClick={(): void => {
                        if (componentsProps) {
                            componentsProps.toolbar.setSelectedRowId([+cellParams.row.id])
                            componentsProps.toolbar.onClickReject(cellParams.row.uuid)
                        }
                    }}
                />
            </Box>
        </Flex>
    )
}
